import React from 'react';
import { CTAButton } from './CTAButton';
export const CustomerReviews = () => {
  return <section id="reviews" className="w-full bg-gray-50 py-16 px-4 border-t border-gray-100" data-id="element-97">
      <div className="max-w-5xl mx-auto" data-id="element-98">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-teal-600 mb-6" data-id="element-99">
          What Our Customers Say
        </h2>
        <div className="flex justify-center mt-2 text-yellow-400 mb-8" data-id="element-100">
          <span className="text-2xl" data-id="element-101">★★★★★</span>
          <span className="ml-2 text-gray-700 font-medium" data-id="element-102">
            Rated 4.9 by 2,000+ Happy Customers
          </span>
        </div>
        {/* Featured Video Testimonial */}
        <div className="mb-12 bg-white rounded-xl p-6 shadow-md" data-id="element-103">
          <h3 className="text-2xl font-semibold text-center text-teal-700 mb-4" data-id="element-104">
            Hear from Beth about her experience
          </h3>
          <div className="max-w-2xl mx-auto mb-4" data-id="element-105">
            <div className="relative pt-[56.25%]" data-id="element-106">
              <iframe src="https://player.vimeo.com/video/1115944217?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;loop=1&amp;muted=1" className="absolute top-0 left-0 w-full h-full rounded-lg" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" title="BethShowingKneeSleeve" data-id="element-107"></iframe>
            </div>
          </div>
          <blockquote className="text-gray-700 italic text-center text-lg mb-4" data-id="element-108">
            "I absolutely love my Ardava knee sleeve! It stays up all day and
            provides the perfect support."
          </blockquote>
          <div className="flex items-center justify-center" data-id="element-109">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 mr-3 border border-teal-100" data-id="element-110">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3JVtjEPcH78ohjixHmv79p/395282767_333088312736901_187241778219682257_n.jpg" alt="Beth" className="w-full h-full object-cover" data-id="element-111" />
            </div>
            <div data-id="element-112">
              <p className="font-medium" data-id="element-113">Beth K.</p>
              <p className="text-sm text-gray-500" data-id="element-114">Verified Buyer</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-115">
          <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-116">
            <div className="flex justify-center mt-2 text-yellow-400 mb-4" data-id="element-117">
              <span data-id="element-118">★★★★★</span>
            </div>
            <blockquote className="text-gray-700 italic mb-6 text-center" data-id="element-119">
              "12-hour retail shift. Soft, breathable—and I didn't tug it once.
              This is the first knee sleeve that actually stays up all day."
            </blockquote>
            <div className="flex items-center justify-center" data-id="element-120">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 mr-3 border border-teal-100" data-id="element-121">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m297Z1iDpGaxSc62mQHUsv/480712971_649456857740330_7407202034390763397_n.jpg" alt="Jessica M." className="w-full h-full object-cover" data-id="element-122" />
              </div>
              <div data-id="element-123">
                <p className="font-medium" data-id="element-124">Jessica M.</p>
                <p className="text-sm text-gray-500" data-id="element-125">Verified Buyer</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-126">
            <div className="flex justify-center mt-2 text-yellow-400 mb-4" data-id="element-127">
              <span data-id="element-128">★★★★★</span>
            </div>
            <blockquote className="text-gray-700 italic mb-6 text-center" data-id="element-129">
              "Stairs used to make me nervous. This feels secure but not tight.
              I can finally take my daily walks without constantly adjusting my
              knee sleeve."
            </blockquote>
            <div className="flex items-center justify-center" data-id="element-130">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 mr-3 border border-teal-100" data-id="element-131">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kdMYRRp1vr1aowUs3CDNek/462329648_2331788223842850_6500544993249107053_n.jpg" alt="Robert B." className="w-full h-full object-cover" data-id="element-132" />
              </div>
              <div data-id="element-133">
                <p className="font-medium" data-id="element-134">Robert B.</p>
                <p className="text-sm text-gray-500" data-id="element-135">Verified Buyer</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-136">
            <div className="flex justify-center mt-2 text-yellow-400 mb-4" data-id="element-137">
              <span data-id="element-138">★★★★★</span>
            </div>
            <blockquote className="text-gray-700 italic mb-6 text-center" data-id="element-139">
              "Replaced two drawer-sleeves with this and finally stopped fussing
              with it. The bamboo material is so comfortable I forget I'm
              wearing it."
            </blockquote>
            <div className="flex items-center justify-center" data-id="element-140">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 mr-3 border border-teal-100" data-id="element-141">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/e5yqWVHriZDLfg23VGjnKE/435298121_847690384042472_2031876560587436062_n.jpg" alt="Teresa K." className="w-full h-full object-cover" data-id="element-142" />
              </div>
              <div data-id="element-143">
                <p className="font-medium" data-id="element-144">Teresa K.</p>
                <p className="text-sm text-gray-500" data-id="element-145">Verified Buyer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl overflow-hidden shadow-md mb-16" data-id="element-146">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-147">
            <div className="p-8" data-id="element-148">
              <h3 className="text-2xl font-bold text-teal-700 mb-4" data-id="element-149">
                Real Use-Case Proof
              </h3>
              <div className="space-y-6 mb-6" data-id="element-150">
                <div className="flex items-start" data-id="element-151">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-152">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oeivRQjjJGxbP17KuNxm8a/482007891_651121187422702_1448267450469549096_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-153" />
                  </div>
                  <div data-id="element-154">
                    <h4 className="font-semibold text-lg" data-id="element-155">Stairs</h4>
                    <p className="text-gray-600 italic" data-id="element-156">
                      "No tugging on the steps today."
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-157">— Linda P., 62</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-158">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-159">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fBmrFTFsYniYsi5SibrN8x/480284748_979159727487644_1705542471202472034_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-160" />
                  </div>
                  <div data-id="element-161">
                    <h4 className="font-semibold text-lg" data-id="element-162">12-hr shift</h4>
                    <p className="text-gray-600 italic" data-id="element-163">
                      "Breathable under scrubs all day."
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-164">— Michelle R., 45</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-165">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-166">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9h9ni6eT1DVWZzwR6yasyu/475845067_614898544521042_4794135321733470433_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-167" />
                  </div>
                  <div data-id="element-168">
                    <h4 className="font-semibold text-lg" data-id="element-169">Travel comfort</h4>
                    <p className="text-gray-600 italic" data-id="element-170">
                      "Perfect for long drives and flights."
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-171">— Pamela D., 53</p>
                  </div>
                </div>
              </div>
              <div className="mt-6" data-id="element-172">
                <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" style={{
                display: 'block'
              }} data-id="element-173">
                  <button className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-medium w-full transition-colors" data-id="element-174">
                    Join Thousands of Happy Customers
                  </button>
                </a>
              </div>
            </div>
            <div className="bg-gray-50 p-8 flex flex-col justify-center" data-id="element-175">
              <div className="bg-white rounded-lg shadow-sm p-6 relative" data-id="element-176">
                <div className="absolute -top-4 -left-4 w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center" data-id="element-177">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-178">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-179" />
                  </svg>
                </div>
                <div className="flex items-center mb-4" data-id="element-180">
                  <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-teal-100 mr-4" data-id="element-181">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4MCo2g1R6nYykgBbAUGNUF/walkingSpecialist-2.webp" alt="Movement Specialist" className="w-full h-full object-cover" data-id="element-182" />
                  </div>
                  <div data-id="element-183">
                    <h3 className="text-xl font-semibold text-teal-700" data-id="element-184">
                      Independent Specialist Review
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-185">
                      Dr. Catherine L., Movement Specialist
                    </p>
                  </div>
                </div>
                <p className="text-gray-700 mb-6" data-id="element-186">
                  An independent movement specialist who reviewed Ardava told us
                  she routinely sees people abandon sleeves after an hour or two
                  because they're hot or irritating.
                </p>
                <p className="text-gray-700 font-medium" data-id="element-187">
                  With Ardava, her wear-testers reported comfortable all-day use
                  and fewer mid-day readjustments—especially on stairs and
                  longer walks.
                </p>
                <div className="mt-4 text-sm text-gray-500" data-id="element-188">
                  * Specialist portrayal for educational purposes only.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-16" data-id="element-189">
          <h3 className="text-2xl font-bold text-center text-teal-700 mb-8" data-id="element-190">
            More Customer Experiences
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-191">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-192">
              <div className="flex items-start mb-4" data-id="element-193">
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-194">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/g9ppAmcEfGEAJSMfzkEJcq/481071606_616457347683998_3419974034531058524_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-195" />
                </div>
                <div data-id="element-196">
                  <div className="flex text-yellow-400 mb-1" data-id="element-197">
                    <span data-id="element-198">★★★★★</span>
                  </div>
                  <h4 className="font-semibold text-lg" data-id="element-199">Sarah & Mike J.</h4>
                  <p className="text-sm text-gray-500" data-id="element-200">Verified Buyers</p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4" data-id="element-201">
                "We both have active lifestyles and were constantly adjusting
                our knee sleeves during outings. Since switching to Ardava, we
                can focus on enjoying our activities instead of constantly
                tugging at our sleeves."
              </blockquote>
              <p className="text-gray-600 italic" data-id="element-202">
                "Perfect for our weekend adventures and daily walks!"
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-203">
              <div className="flex items-start mb-4" data-id="element-204">
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-205">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/817R3vci7iAymsWimh3n5g/293765685_119469420810541_3448458718366110944_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-206" />
                </div>
                <div data-id="element-207">
                  <div className="flex text-yellow-400 mb-1" data-id="element-208">
                    <span data-id="element-209">★★★★★</span>
                  </div>
                  <h4 className="font-semibold text-lg" data-id="element-210">Margaret S.</h4>
                  <p className="text-sm text-gray-500" data-id="element-211">Verified Buyer</p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4" data-id="element-212">
                "As a yoga instructor with mild knee discomfort, I needed
                something that wouldn't interfere with my practice. The Ardava
                sleeve provides just the right amount of support without
                limiting my range of motion."
              </blockquote>
              <p className="text-gray-600 italic" data-id="element-213">
                "It stays in place through my entire 90-minute class!"
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-214">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-215">
              <div className="flex items-start mb-4" data-id="element-216">
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-217">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uRdJAEfWjwzPC9EnhLdn9o/475794021_553754617713248_1161662369710353743_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-218" />
                </div>
                <div data-id="element-219">
                  <div className="flex text-yellow-400 mb-1" data-id="element-220">
                    <span data-id="element-221">★★★★★</span>
                  </div>
                  <h4 className="font-semibold text-lg" data-id="element-222">Priya N.</h4>
                  <p className="text-sm text-gray-500" data-id="element-223">Verified Buyer</p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4" data-id="element-224">
                "I've tried so many knee sleeves that either cut off circulation
                or slide down constantly. The Ardava sleeve is different - it
                provides steady support without feeling restrictive, even during
                long days running errands."
              </blockquote>
              <p className="text-gray-600 italic" data-id="element-225">
                "First sleeve I've found that's both comfortable and
                functional!"
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-226">
              <div className="flex items-start mb-4" data-id="element-227">
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-228">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/27E4y7D38KDaHSQjkhueZG/472223111_122138298494546773_1273624044471592908_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-229" />
                </div>
                <div data-id="element-230">
                  <div className="flex text-yellow-400 mb-1" data-id="element-231">
                    <span data-id="element-232">★★★★★</span>
                  </div>
                  <h4 className="font-semibold text-lg" data-id="element-233">Jennifer T.</h4>
                  <p className="text-sm text-gray-500" data-id="element-234">Verified Buyer</p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4" data-id="element-235">
                "After knee replacement surgery, I needed gentle support during
                recovery. The Ardava sleeve has been perfect - not too tight,
                breathable, and it doesn't irritate my skin like my previous
                medical-grade sleeve did."
              </blockquote>
              <p className="text-gray-600 italic" data-id="element-236">
                "My physical therapist even asked where I got it!"
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-237">
              <div className="flex items-start mb-4" data-id="element-238">
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-239">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sa6iQwGE6F2BSER5jLe6Tz/475836123_507688895680793_5718935428441614724_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-240" />
                </div>
                <div data-id="element-241">
                  <div className="flex text-yellow-400 mb-1" data-id="element-242">
                    <span data-id="element-243">★★★★★</span>
                  </div>
                  <h4 className="font-semibold text-lg" data-id="element-244">Patricia L.</h4>
                  <p className="text-sm text-gray-500" data-id="element-245">Verified Buyer</p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4" data-id="element-246">
                "I've been wearing knee supports for years due to arthritis. The
                Ardava sleeve is the first one that doesn't feel like a medical
                device. It's comfortable enough to wear all day and provides
                just the right amount of support."
              </blockquote>
              <p className="text-gray-600 italic" data-id="element-247">
                "Perfect balance of support and comfort!"
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-id="element-248">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-249">
              <div className="flex items-start mb-4" data-id="element-250">
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-251">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mwXf5h9o4PRuvAQxtEdjrm/400035716_215705108212508_5005528371540526880_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-252" />
                </div>
                <div data-id="element-253">
                  <div className="flex text-yellow-400 mb-1" data-id="element-254">
                    <span data-id="element-255">★★★★★</span>
                  </div>
                  <h4 className="font-semibold text-lg" data-id="element-256">Natasha K.</h4>
                  <p className="text-sm text-gray-500" data-id="element-257">Verified Buyer</p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4" data-id="element-258">
                "As someone who's always dressed up for work, I needed a knee
                sleeve that wouldn't be obvious under dresses and skirts. The
                Ardava sleeve is so low-profile that no one even notices I'm
                wearing it, yet it provides all the support I need."
              </blockquote>
              <p className="text-gray-600 italic" data-id="element-259">
                "Discreet support that doesn't compromise my style!"
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-260">
              <div className="flex items-start mb-4" data-id="element-261">
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden border border-teal-100 mr-4" data-id="element-262">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qkyZRHWCRNnszZ95MrFoko/49055716_287537988574946_6084152132078927872_n.jpg" alt="Customer testimonial" className="w-full h-full object-cover" data-id="element-263" />
                </div>
                <div data-id="element-264">
                  <div className="flex text-yellow-400 mb-1" data-id="element-265">
                    <span data-id="element-266">★★★★★</span>
                  </div>
                  <h4 className="font-semibold text-lg" data-id="element-267">Barbara M.</h4>
                  <p className="text-sm text-gray-500" data-id="element-268">Verified Buyer</p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4" data-id="element-269">
                "I've tried a bunch of sleeves—most got hot or slid down.
                Ardava's bamboo knit stays comfortable through long days, and
                the tapered cuff + micro-grip means I'm not stopping to tug it
                up. Supportive without bulk, and it disappears under leggings."
              </blockquote>
              <p className="text-gray-600 italic" data-id="element-270">
                "Support without the brace vibe."
              </p>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-271">
          <CTAButton text="Get Your Ardava Sleeve Today — 60-Day Guarantee" data-id="element-272" />
        </div>
      </div>
    </section>;
};